import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/Logo_JUCO.png';

export const SimpleNavbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-transparent backdrop-blur-sm border-b border-slate-700/30">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center -my-2">
            <img
              src={logo}
              alt="JUCO Pipeline Logo"
              className="h-24 sm:h-28 md:h-40 w-auto mt-4"
            />
          </Link>

          {/* Support Link */}
          <Link 
            to="/support" 
            className="text-gray-300 hover:text-white text-sm sm:text-base font-medium transition-colors"
          >
            SUPPORT
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default SimpleNavbar;
